// extracted by mini-css-extract-plugin
export var cardIcon = "_an-4";
export var checkboxCard = "_an-0";
export var checkboxCardSelected = "_an-1";
export var disabled = "_an-2";
export var outerBorder = "_an-3";
export var spacerMedium = "_an-7";
export var spacerSmall = "_an-6";
export var spacerXsmall = "_an-5";